import { __url } from '../../absoluteUrls/absoluteUrlTranslations';
import { DS_BRIEF_BASE_URL, DS_BRIEF_CREATE_URL, DS_BRIEF_MULTI_STEP_URL } from '../consts';

export function getBriefBaseUrl() {
    if (process.env.NODE_ENV === 'development') {
        return DS_BRIEF_BASE_URL;
    }
    return __url(`${DS_BRIEF_BASE_URL}`);
}

export function getBriefMultiStepUrl(id?: string) {
    let baseUrl: string;
    if (process.env.NODE_ENV === 'development') {
        baseUrl = `http://localhost:3002${DS_BRIEF_MULTI_STEP_URL}`;
    } else {
        baseUrl = __url(`${DS_BRIEF_MULTI_STEP_URL}`);
    }
    if (id) {
        return `${baseUrl}/${id}?step=1`;
    }
    return baseUrl;
}

export function getRequestBriefCreateUrl() {
    if (process.env.NODE_ENV === 'development') {
        return `http://localhost:3002/experts/request/brief/create`;
    }
    return '/experts/request/brief/create';
}

export function getBriefCreateURL(mpvID?: string) {
    const mpvIDParam = mpvID ? `?mpvId=${mpvID}` : '';

    if (process.env.NODE_ENV === 'development') {
        return `${DS_BRIEF_CREATE_URL}/other-design${mpvIDParam}`;
    }
    return `${__url(`${DS_BRIEF_CREATE_URL}`)}/other-design${mpvIDParam}`;
}
